import React from 'react'
import PropTypes from 'prop-types'
import { formatPrice } from 'Utils/inputUtils'
import ArchiveCard from '../ArchiveCard'
import VerticalTimeline from '../VerticalTimeline'
import VerticalTimelineElementSimple from '../VerticalTimelineElementSimple'
import { _ArchiveListContainer } from './styles'

const ArchiveList = ({
  isPrint,
  archiveListingsData,
  showPastSaleOnClick,
  userIsAuthentificated,
  children,
  handleInnerCollapsibleOnClick,
  handleContactAgentClick,
  isUserAgentAdminSupport,
  pageFrom,
  userEmailVerified,
  showLoginModal,
}) => {
  const {
    date_groups: dateGroups,
    building_address: address,
  } = archiveListingsData

  if(pageFrom === 'listing') {
    const allListings = archiveListingsData.date_groups.reduce(
      (accumulator, group) => accumulator.concat(group.listings), [])
    return (
      <>
        <_ArchiveListContainer>
          {allListings.map((listing, index) => {
            const askingPrice = formatPrice(listing.asking_price)
            const closedPrice = formatPrice(listing.closed_price)
            const status = listing.status
            const sqft = (userIsAuthentificated && listing.sqft) || 0
            const key = `${userIsAuthentificated + index}_${
              listing.mls_number
            }_${listing.suite_number}`
            return (
              <ArchiveCard
                key={key}
                listingHash={listing._id}
                userIsAuthentificated={userIsAuthentificated}
                showPastSaleOnClick={() =>
                  showPastSaleOnClick(listing.mls_number)
                }
                handleContactAgentClick={(e) => handleContactAgentClick(e, listing, true)}
                imgSrc={listing.photo}
                askingPrice={askingPrice}
                closedPrice={closedPrice === 0 ? null : closedPrice}
                beds={listing.bed_type}
                baths={listing.bathrooms}
                parkings={listing.parking_spots}
                photoVersion={listing.photo_version}
                sqft={sqft}
                url={listing.url}
                endDate={
                  userIsAuthentificated
                    ? listing.end_date || ''
                    : listing.end_date
                }
                entryDate={listing.entry_date}
                suiteNumber={
                  listing.unit_name === 'Login Required'
                    ? null
                    : listing.unit_name
                }
                status={status === 'Suspended' ? 'Terminated' : status}
                lastItem={index === allListings.length - 1}
                firstItem={index === 0}
                isPrint={isPrint}
                sqftMax={listing.sqft_max}
                sqftMin={listing.sqft_min}
                streetAddress={listing.street_address || ''}
                address={address || listing.title}
                hiddenFields={isUserAgentAdminSupport ? {} : listing.hidden_fields}
                userIsOneOfAgentAdminSupport={isUserAgentAdminSupport}
                listingPage
                listing={listing}
                userEmailVerified={userEmailVerified}
                showLoginModal={showLoginModal}
              />
            )
          })}
        </_ArchiveListContainer>
        {children}
      </>
    )
  }

  const isAddressPage = pageFrom === 'Address'

  return (
    <VerticalTimeline>
      {dateGroups.map((group, groupIndex) => {
        const {
          date,
          listing_count: listingCount,
          listings_sold_count: listingsSoldCount,
          listings_rent_count: listingsRentCount,
          listings,
        } = group
        return (
          <VerticalTimelineElementSimple
            className="vertical-timeline-element--work"
            date={date}
            listed={listingCount}
            soldRentCount={
              listingsSoldCount || listingsSoldCount === 0
                ? listingsSoldCount
                : listingsRentCount
            }
            key={date}
            isLastElement={groupIndex === dateGroups.length - 1}
            status={
              listingsSoldCount || listingsSoldCount === 0 ? 'Sold' : 'Rented'
            }
            handleInnerCollapsibleOnClick={handleInnerCollapsibleOnClick}
            isAddressPage={isAddressPage}
          >
            <_ArchiveListContainer>
              {listings.map((listing, index) => {
                const askingPrice = formatPrice(listing.asking_price)
                const closedPrice = formatPrice(listing.closed_price)
                const status = listing.status
                const sqft = (userIsAuthentificated && listing.sqft) || 0
                const key = `${userIsAuthentificated + index}_${
                  listing.mls_number
                }_${listing.suite_number}`
                return (
                  <ArchiveCard
                    key={key}
                    listingHash={listing._id}
                    listing={listing}
                    showPastSaleOnClick={() =>
                      showPastSaleOnClick(listing.mls_number)
                    }
                    handleContactAgentClick={(e) => handleContactAgentClick(e, listing, true)}
                    imgSrc={listing.photo}
                    askingPrice={askingPrice}
                    closedPrice={closedPrice === 0 ? null : closedPrice}
                    beds={listing.bed_type}
                    baths={listing.bathrooms}
                    parkings={listing.parking_spots}
                    photoVersion={listing.photo_version}
                    sqft={sqft}
                    url={listing.url}
                    endDate={
                      userIsAuthentificated
                        ? listing.end_date || ''
                        : listing.end_date
                    }
                    entryDate={listing.entry_date}
                    suiteNumber={
                      listing.unit_name === 'Login Required'
                        ? null
                        : listing.unit_name
                    }
                    status={status === 'Suspended' ? 'Terminated' : status}
                    lastItem={index === listings.length - 1}
                    firstItem={index === 0}
                    isPrint={isPrint}
                    sqftMax={listing.sqft_max}
                    sqftMin={listing.sqft_min}
                    streetAddress={listing.street_address || ''}
                    address={address || listing.title}
                    hiddenFields={isUserAgentAdminSupport ? {} : listing.hidden_fields}
                    userIsOneOfAgentAdminSupport={isUserAgentAdminSupport}
                    listingPage={isAddressPage}
                    userIsAuthentificated={userIsAuthentificated}
                    userEmailVerified={userEmailVerified}
                    showLoginModal={showLoginModal}
                  />
                )
              })}
            </_ArchiveListContainer>
          </VerticalTimelineElementSimple>
        )
      })}
      {children}
    </VerticalTimeline>
  )
}

ArchiveList.propTypes = {
  isPrint: PropTypes.bool,
  userIsAuthentificated: PropTypes.bool,
  archiveListingsData: PropTypes.shape({
    date_groups: PropTypes.arrayOf(PropTypes.shape({})),
    building_address: PropTypes.string,
  }).isRequired,
  showPastSaleOnClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  handleInnerCollapsibleOnClick: PropTypes.func,
  handleContactAgentClick: PropTypes.func,
  isUserAgentAdminSupport: PropTypes.bool,
  pageFrom: PropTypes.string,
  userEmailVerified: PropTypes.bool,
  showLoginModal: PropTypes.func,
}

export default ArchiveList
